import { type AxiosError, type Method as AxiosMethod } from 'axios'
import { fetchNoCatch } from '@dhl/fetch'

// README: when changing this construction make sure to change
// in locator app as well!
const getBaseUrl = () =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-underscore-dangle
  (window as any).env?.API_LOCATOR || (window as any).__dhlConfig?.API_LOCATOR || ''

type Arg = {
  url: string
  method: AxiosMethod
  headers?: Record<string, string>
  params?: Record<string, string | string[] | number | boolean | undefined>
  data?: unknown
  signal?: AbortSignal
  responseType?: string | Blob
}

type Options = {
  timeout?: number
}

export const client = async <T>(
  { url, method = 'GET', params, headers, data, signal }: Arg,
  options?: Options
): Promise<T> => {
  const urlParams = params
    ? new URLSearchParams(
        Object.keys(params).reduce(
          (acc, key) => (params[key] === undefined ? { ...acc } : { ...acc, [key]: params[key] }),
          {}
        )
      )
    : ''

  return fetchNoCatch({
    url: `${getBaseUrl()}${url}${params ? `?${urlParams}` : ''}`,
    method,
    headers,
    ...(data ? { body: JSON.stringify(data) } : {}),
    signal,
    timeout: options?.timeout,
  })
}

// Axios errors will return data in a different way our generated client with TError is expecting,
// so we are adding it here so our generated client will know
// For example when we throw a 400 with a key we can get it like `mutation.error?.response?.data?.key`
// same to know its status etc its now correctly typed since we are using Axios
export type ErrorType<Error> = AxiosError<Error>
